// extracted by mini-css-extract-plugin
export default {"ModalContent":"CreateOAuth_ModalContent__R7aM9"};